import { render, staticRenderFns } from "./planDetails.vue?vue&type=template&id=e5b5e684"
import script from "./planDetails.vue?vue&type=script&lang=js"
export * from "./planDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports